import { Trans } from '@lingui/react/macro';
import { SalesItemBookingCategoryType } from '@navio/nsdk';
import { BookingStoreCar } from 'noddi-types';
import { getCarName } from '../../../utils/carName';
import { CarImage } from '../../Common/CarImage';

export const CarIdentifierWithIcon = ({
  car,
  hideTireHotelInfo,
  bookingCategories
}: {
  car: BookingStoreCar;
  hideTireHotelInfo?: boolean;
  bookingCategories?: string[];
}) => {
  const hasWheelServices =
    bookingCategories?.map((category) => category === SalesItemBookingCategoryType.WHEEL_SERVICES).includes(true) ??
    false;

  return (
    <div className='flex items-center gap-4'>
      <CarImage car={car} alt='' size='thumbnail' />
      <div className='flex flex-col'>
        <span className='font-semibold'>{getCarName({ car, showLicensePlate: true })}</span>
        {!hideTireHotelInfo && (!!car.hasTireHotel || !!car.wheelStorage?.length) && hasWheelServices && (
          <span>
            <Trans>We have your tires stored with us</Trans>
          </span>
        )}
      </div>
    </div>
  );
};
